/**
 * Titolo della scheda, favicon e icona per la schermata Home secondo il prodotto del dominio
 * (es. app.mindleadconstruction.com → logo Construction). Gira all'avvio, prima di React.
 * Le icone stanno in public/branding/icons/: per un nuovo prodotto basta aggiungere
 * <prodotto>.svg, <prodotto>-32.png e <prodotto>-180.png e la voce qui sotto.
 */
import { PRODUCTS, type ProductKey } from "./products";
import { platform } from "./runtime";

const ICON_SET: Partial<Record<ProductKey, string>> = {
  construction: "construction",
};

function setLink(rel: string, href: string, type?: string, sizes?: string) {
  const selector = `link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ""}${type ? `[type="${type}"]` : ""}`;
  let el = document.head.querySelector<HTMLLinkElement>(selector);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    if (type) el.type = type;
    if (sizes) el.setAttribute("sizes", sizes);
    document.head.appendChild(el);
  }
  el.href = href;
}

export function applyProductHead() {
  if (typeof document === "undefined") return;
  const product = platform.product;
  if (!product) return; // host tutto-in-uno: restano titolo e icona della Suite (index.html)
  const icons = ICON_SET[product] ?? "suite";
  document.title = PRODUCTS[product].name;
  setLink("icon", `/branding/icons/${icons}.svg`, "image/svg+xml");
  setLink("icon", `/branding/icons/${icons}-32.png`, "image/png", "32x32");
  setLink("apple-touch-icon", `/branding/icons/${icons}-180.png`);
  document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", PRODUCTS[product].name);
}

applyProductHead();
